import React, { useState, useEffect, useCallback } from "react";
import { Grid, CardHeader, CardContent, Box, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Form, FormikProvider, useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CardLayout from "../../layouts/CardLayout";
import errorHandler from "../../utils/errorHandler";
import { modelServices } from "../../services/AllServices";
import * as Yup from "yup";
import { capitalize } from "../../utils/helpers";

function ModelCommission() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchTaskData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const response = await modelServices.getById({ id });
        setData(response?.data?.data?.modelCharctersticks);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchTaskData();
  }, [fetchTaskData]);

  const validationSchema = Yup.object({
    exclusivePrivatePrice: Yup.number().required("Required"),
    groupShowPrice: Yup.number().required("Required"),
    privatePrice: Yup.number().required("Required"),
    spyingPrice: Yup.number().required("Required"),
    ticketShowPrice: Yup.number().required("Required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      id:data?._id,
      exclusivePrivatePrice: data?.exclusivePrivatePrice || "",
      groupShowPrice: data?.groupShowPrice || "",
      modelId: data?.modelId || "",
      privatePrice: data?.privatePrice || "",
      spyingPrice: data?.spyingPrice || "",
      ticketShowPrice: data?.ticketShowPrice || "",
    },
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = modelServices.comissionUpdate(values);
        toast.success(response?.data?.message, { toastId: "success" });
        navigate(-1);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const { values, touched, errors, handleChange, handleSubmit } = formik;

  return (
    <Box>
      <CardLayout>
        <CardHeader title={`Performer ${id ? "Edit" : "Add"} Commission`} />
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {[
                  "exclusivePrivatePrice",
                  "groupShowPrice",
                  "privatePrice",
                  "spyingPrice",
                  "ticketShowPrice",
                ].map((field) => (
                  <Grid item xs={6} md={6} key={field}>
                    <TextField
                      fullWidth
                      label={capitalize(field.replace(/([A-Z])/g, " $1").trim())}
                      required
                      name={field}
                      value={values[field]}
                      onChange={handleChange}
                      error={Boolean(touched[field] && errors[field])}
                      helperText={touched[field] && errors[field]}
                      type="number"
                    />
                  </Grid>
                ))}
                <Grid item xs={12} md={12}>
                  <Box mt={3}>
                    <LoadingButton
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      loading={loading}
                    >
                      {id ? "Update" : "Add"} Commission
                    </LoadingButton>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default ModelCommission;
